import { Dialog, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { Policy } from '../../types/policy.types';
import { DocumentViewer } from '../Viewers/DocumentViewer';
import styles from './LegalModal.module.css';

interface LegalSection {
	section: string;
	text: string;
}

interface LegacyLegalContent {
	title: string;
	lastUpdated: string;
	version: string;
	lgpdCompliant?: boolean;
	content: LegalSection[];
}

interface LegalModalProps {
	open: boolean;
	onClose: () => void;
	policy?: Policy | null;
	content?: LegacyLegalContent;
}

export const LegalModal = ({ open, onClose, policy, content }: LegalModalProps) => {
	const policyToDisplay = policy || (content ? convertLegacyToPolicy(content) : null);

	return (
		<Dialog
			open={open}
			onClose={onClose}
			maxWidth="lg"
			fullWidth
			slotProps={{
				paper: {
					className: styles.dialog,
				},
			}}
		>
			<div className={styles.header}>
				<IconButton onClick={onClose} className={styles.closeButton} aria-label="Fechar">
					<Close />
				</IconButton>
			</div>

			<div className={styles.content}>
				<DocumentViewer policy={policyToDisplay} isModal />
			</div>
		</Dialog>
	);
};

function convertLegacyToPolicy(legacy: LegacyLegalContent): Policy {
	const markdownContent = legacy.content
		.map((section) => {
			return `# ${section.section}\n\n${section.text}\n\n`;
		})
		.join('');

	return {
		_id: `legacy-${Date.now()}`,
		policyType: legacy.title.toLowerCase().includes('privacidade')
			? 'privacy_policy'
			: 'terms_of_use',
		title: legacy.title,
		description: legacy.lgpdCompliant ? 'Conforme LGPD' : '',
		versionNumber: legacy.version,
		content: markdownContent,
		effectiveDate: legacy.lastUpdated,
		isActive: true,
		updatedAt: legacy.lastUpdated,
	};
}
